import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CustomSegmentedTabs from '../_common/tabs/segmentedTabs';
export default function TabsABOType(_a) {
    var activeTabABOType = _a.activeTabABOType, setActiveTabABOType = _a.setActiveTabABOType, standardRef = _a.standardRef, premiumRef = _a.premiumRef, premiumPlusRef = _a.premiumPlusRef, selectBackdrops = _a.selectBackdrops, backdrops = _a.backdrops;
    var handleClickTabABOType = function (title, tabsName) {
        setActiveTabABOType(title);
        var initialSelectedBackdrop = null;
        if (backdrops) {
            var filteredBackdrops = backdrops.filter(function (bdp) { return bdp.tag.includes(title.replace('ABO ', '')); });
            initialSelectedBackdrop = filteredBackdrops.length > 0 ? filteredBackdrops[0] : null;
        }
        if (initialSelectedBackdrop) {
            selectBackdrops([initialSelectedBackdrop]);
        }
    };
    var scrollToRef = function (ref) {
        if (ref.current) {
            var element = document.getElementById("backdrops");
            if (element) {
                var offsetTop = ref.current.offsetTop - 430;
                element.scrollTo({ behavior: 'smooth', top: offsetTop });
            }
        }
    };
    var tabsABOType = [
        {
            defaultValue: "ABO Standard", handleClick: function () {
                handleClickTabABOType('ABO Standard', 'tabsABOType'),
                    scrollToRef(standardRef);
            }, id: "4", title: 'ABO Standard', value: 0, widthTab: '33.3%'
        },
        {
            defaultValue: "ABO Premium", handleClick: function () {
                handleClickTabABOType('ABO Premium', 'tabsABOType'),
                    scrollToRef(premiumRef);
            }, id: "5", title: 'ABO Premium', value: 1, widthTab: '33.3%'
        },
        {
            defaultValue: "ABO Premium+", handleClick: function () {
                handleClickTabABOType('ABO Premium+', 'tabsABOType'),
                    scrollToRef(premiumPlusRef);
            }, id: "6", title: 'ABO Premium+', value: 2, widthTab: '33.3%'
        }
    ];
    return (_jsx(CustomSegmentedTabs, { tabsData: tabsABOType, heightTab: "50px", widthTabs: '547px', activeTab: activeTabABOType, tabsName: 'tabsABOType' }));
}
